/* eslint-disable max-len */
import { getLanguageCode, languageCodeAndCountryMap } from '@helpers/languages';
import { getLoginOktaTranslation } from '@oktaConfig/oktaTranslation';

const CLIENT_ID = '';
const BASE_URL = '';
const ISSUER = '';

const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const REDIRECT_URI = `${window.location.origin}/`;
const FORGOT_PASSWORD_URL = `${window.location.origin}/forgot-password`;
const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/login`;

/**
 * prefill username/business email field when the browser URL has the query parameter as uid
 * example : http://<url>/login?uid=author@dnb.com
 */
const urlParams = new URLSearchParams(window.location.search.slice(1));
const prefillUsername = urlParams.has('uid') ? `${urlParams.get('uid')}` : '';
const isDunsFlow = window.location.pathname.startsWith('/signin');
// if localStorage is set use stored language other wise english
const language = getLanguageCode();
const translationLanguageCode: string = languageCodeAndCountryMap[language] || 'en';
const oktaLoginTranslationObj = getLoginOktaTranslation(isDunsFlow);

export default {
    oidc: {
        clientId: CLIENT_ID,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
        issuer: ISSUER,
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    },
    config: {
        baseUrl: BASE_URL,
        clientId: CLIENT_ID,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
        username: prefillUsername,
        language: translationLanguageCode,
        i18n: {
            [translationLanguageCode]: {
                ...oktaLoginTranslationObj[translationLanguageCode],
            },
        },
        authParams: {
            responseType: ['id_token', 'token'],
            // pkce: true,
            issuer: ISSUER,
            scopes: ['openid', 'profile', 'email'],
        },

        features: {
            showPasswordToggleOnSignInPage: true, // ✅ Required for "eye" icon
            rememberMe: true,
            idpDiscovery: false,
            hideSignOutLinkInMFA: true
        },

        helpLinks: {
            forgotPassword: FORGOT_PASSWORD_URL,
        },

        // This  will append the '@no-domain.com' domain if the user has not entered it
        transformUsername: (username: string): string => (username.split('@')[1]
            ? username
            : `${username}@no-domain.com`),

        useClassicEngine: true
    },
};